// extracted by mini-css-extract-plugin
export default {"zoomModal":"w3-z","image":"x3-z","button":"y3-z","isOverlayShown":"z3-z"};